import {
  FIND_ASSIGNABLE_PRODUCT_FILES,
  SortDirectionEnum,
} from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFileColumns } from './useFileColumns';

export type ProductFilesAssignListProps = {
  workspaceId: string;
  productId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const ProductFilesAssignList = ({
  workspaceId,
  productId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: ProductFilesAssignListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() =>
    workspaceId
      ? { keyword, productId, assignments: assignments || [], workspaceId }
      : undefined
  );

  const columns = useFileColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    if (!workspaceId) return;
    setFilter({ keyword, productId, assignments, workspaceId });
  }, [keyword, productId, workspaceId]);

  if (!filter) return null;

  return (
    <InfiniteDataGrid
      modelName="file"
      hideResultsLabel={true}
      query={FIND_ASSIGNABLE_PRODUCT_FILES}
      filter={filter}
      pageSize={100}
      columns={columns}
      listMaxHeight={maxHeight as number}
      containerStyle={{ height: maxHeight }}
      paddingBottom={0}
      textEmpty={t('files.textEmpty')}
      dataPrefix="product.findAssignableFilesForProduct"
      updateRowsSelected={(rows) => updateAssignments(rows.map(row => row.id))}
      isRowSelected={(row) => assignments.includes(row.id)}
      enableScrollRefresh={true}
      showScrollIndicator={true}
    />
  );
};
